import { Injectable } from '@angular/core';
import { Cms, ICarDetails } from '@impact/data';
import { Observable } from 'rxjs';
import { BookNewCarTestDriveModel } from '../book-new-car-test-drive/book-new-car-test-drive.component';
import { ContentService } from '../content/content.service';
import { DialogService } from '../utils/dialog/dialog.service';
import { SidePanel, SidePanelSize } from './side-panel-types';

@Injectable({
    providedIn: 'root',
})
export class SidePanelService {
    constructor(
        private contentService: ContentService,
        private dialogService: DialogService
    ) {}

    getSidepanelContentAndOpen(url: string, sidePanelSize: SidePanelSize) {
        this.contentService.getSidepanel(url).subscribe(
            (content) => this.openSidePanel({
                    ...content,
                    sidePanelSize,
                }),
            () =>
                this.openSidePanel({
                    errorMessage:
                        'Failed to load content. Please try again later.',
                    sidepanelContent: 'Error',
                    sidePanelSize,
                })
        );
    }

    async openSidePanel(componentData: SidePanel) {
        const { SidePanelComponent } = await import('./side-panel.component');

        this.dialogService.openDialogWithComponent(SidePanelComponent, {
            fullHeight: true,
            blockScroll: true,
            hasBackdrop: true,
            data: {
                component: 'sidepanel',
                componentData,
            },
            positionHorizontal: {
                placement: 'right',
            },
        });
    }

    showAskTheExpert() {
        this.openSidePanel({
            sidepanelContent: 'Ask the expert',
            sidePanelSize: 'medium',
        });
    }

    showBookNewCarTestDriveSidePanel(
        modelData: BookNewCarTestDriveModel,
        preSelectedOption?: string
    ) {
        this.openSidePanel({
            sidepanelContent: 'Book New Car Test Drive',
            sidePanelSize: 'medium',
            modelData,
            preSelectedOption,
        });
    }

    showBookUsedCarTestDriveSidePanel(
        car$: Observable<ICarDetails>,
        preSelectedOption?: string
    ) {
        this.openSidePanel({
            sidepanelContent: 'Book Used Car Test Drive',
            sidePanelSize: 'medium',
            car$,
            preSelectedOption,
        });
    }

    showExhangeCarSidePanel(withLeadGeneration?: boolean) {
        this.openSidePanel({
            sidepanelContent: 'Exhange car',
            sidePanelSize: 'medium',
            withLeadGeneration: !!withLeadGeneration,
        });
    }

    showGetNewCarOfferSidePanel(modelData: Cms.VehicleModel) {
        this.openSidePanel({
            modelData,
            sidepanelContent: 'Get New Car Offer',
            sidePanelSize: 'medium',
        });
    }

    showLoanCalculatorSidePanel(loanData?: any) {
        this.openSidePanel({
            objectPrice: loanData?.objectPrice,
            registrationDate: loanData?.registrationDate,
            sidepanelContent: 'Loan Calculation',
            sidePanelSize: 'large',
        });
    }

    showIndicataInfoSidePanel() {
        this.openSidePanel({
            sidepanelContent: 'Indicata info',
            sidePanelSize: 'medium',
        });
    }
}
